export default {"src":"/_next/static/image/public/images/ic_no_package_default.01db32018a22febc1bb2dd670c4894e3.svg","height":141,"width":129};